/**
 * Convert a MIME type to a standard file extension.
 * Returns an empty string if unknown.
 */
export const getFileExtensionFromMimeType = (
  mimeType: string | undefined,
): string => {
  if (!mimeType) return "";

  const map: Record<string, string> = {
    // Images
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/webp": "webp",
    "image/avif": "avif",
    "image/heic": "jpg", // converted to jpg for compatibility
    "image/heif": "jpg",
    "image/gif": "gif",
    "image/svg+xml": "svg",
    "image/tiff": "tiff",
    "image/bmp": "bmp",
    "image/x-icon": "ico",
    "image/vnd.adobe.photoshop": "psd",

    // Videos
    "video/mp4": "mp4",
    "video/webm": "webm",
    "video/quicktime": "mov",
    "video/x-msvideo": "avi",
    "video/x-matroska": "mkv",

    // Audio
    "audio/mpeg": "mp3",
    "audio/wav": "wav",
    "audio/ogg": "ogg",
    "audio/webm": "webm",
    "audio/aac": "aac",
    "audio/flac": "flac",

    // Documents
    "application/pdf": "pdf",
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      "docx",
    "application/vnd.ms-excel": "xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.ms-powerpoint": "ppt",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      "pptx",
    "application/json": "json",
    "application/zip": "zip",
    "application/x-rar-compressed": "rar",
    "application/vnd.7z-compressed": "7z",

    // Text
    "text/plain": "txt",
    "text/csv": "csv",
    "text/html": "html",
    "text/css": "css",
    "text/javascript": "js",
  };

  mimeType = mimeType.toLowerCase();
  if (map[mimeType]) return map[mimeType];

  // Fallback: take the subtype after '/'
  const parts = mimeType.split("/");
  return parts[1]?.split("+")[0] || "";
};
